// Active → Reporting: race has finished, entering post-race reporting phase.

import React, { JSX } from 'react';
import EventStatusTransitionDialogFrame from './EventStatusTransitionDialogFrame';

type Props = {
  open: boolean;
  eventId: string;
  eventName?: string;
  subtitleOverride?: string;
  busy: boolean;
  onCancel: () => void;
  onProceed: () => void | Promise<void>;
};

export default function ActiveToReportingConfirmDialog(props: Props): JSX.Element | null {
  const { open, eventId, eventName, subtitleOverride, busy, onCancel, onProceed } = props;
  const titleName =
    (subtitleOverride?.trim() ? subtitleOverride.trim() : null) ||
    (eventName?.trim() ? eventName : eventId);

  return (
    <EventStatusTransitionDialogFrame
      open={open}
      busy={busy}
      onCancel={onCancel}
      onProceed={onProceed}
      titleId="active-to-reporting-title"
      eyebrow="Race reporting"
      title="Move to Reporting"
      subtitle={titleName}
      headerAccent="indigo"
      warningTitle="This operation cannot be undone"
      warningBody={
        <>
          Moving to Reporting signals that the race is finished and post-race data processing is
          underway. Device assignments remain locked. Device retrieval can still be recorded.
        </>
      }
      operationIntro={
        <>
          <p>
            You are closing out <span className="font-semibold text-gray-800 dark:text-slate-200">Active</span> and
            moving this race to <span className="font-semibold text-gray-800 dark:text-slate-200">Reporting</span>.
            Use this when the race is physically over and you are ready to process results and retrieve devices.
          </p>
        </>
      }
      confirmPhrase="REPORTING"
      confirmInputId="active-to-reporting-confirm-input"
      proceedButtonText="Proceed to Reporting"
      proceedUseSuccessTone
    />
  );
}
